/**
 * Phone HUD: dock a dialog to a screen edge and let it fold away into a small arrow tab there
 * (chat on the left, menu on the right). Styling lives in style.less (`.collapsible`).
 */
export function makeCollapsible(dialog: any, side: 'left' | 'right', startCollapsed = true): void {
  const el = dialog._element;
  const arrow = $('<div class="collapse-arrow" />');
  el.addClass(`collapsible collapse-${side}`).append(arrow);

  // the arrow points the way the panel will move
  const [open, close] = side === 'left' ? ['▶', '◀'] : ['◀', '▶'];
  const set = (collapsed: boolean) => {
    el.toggleClass('collapsed', collapsed);
    arrow.text(collapsed ? open : close);
  };
  arrow.on('click', () => set(!el.hasClass('collapsed')));
  set(startCollapsed);
}
